import { createContext, useContext } from 'react';
import { AtcCellModel } from './cell.model';
import { Assert } from '@cotera/utilities';

export const AtcContext = createContext<{
  model: AtcCellModel;
} | null>(null);

export const useAtcCellModel = () => {
  const context = useContext(AtcContext);
  Assert.assert(context !== null, 'Atc context not found');

  return context.model;
};
